import { ButtonSize, ButtonVariant } from "./types";

export const baseClass = "text-base rounded-md items-center inline-flex gap-2 justify-center disabled:!opacity-70 whitespace-nowrap";

export const iconBaseClass = "self-center";

/** Padding + height per size. Shared so anything sitting beside a Button lines up with it. */
export const getSizeClass = (size: ButtonSize) => ({
  "px-3 py-2 h-[28px]": size === "xs",
  "px-3 py-2 h-[32px]": size === "sm",
  "px-3 sm:px-5 py-1.5 sm:py-2.5 h-[32px] sm:h-[40px]": size === "md",
  "px-6 py-3.5 h-[44px]": size === "lg",
  "px-7 py-4 h-[56px]": size === "xl",
});

/**
 * The caret half of a split button — the white divider, primary fill and tighter padding.
 *
 * Shared by `Button` (its `isDropdown` mode, used by the Client Manager Actions menu) and
 * `ButtonDropdown` (where the caret is a real menu trigger), so the two can't visually drift.
 */
export const getDropdownCaretClass = (size: ButtonSize, disabled?: boolean) => [
  "flex items-center justify-center rounded-r-md transition-colors",
  getSizeClass(size),
  {
    "bg-primary hover:bg-primary-dark border-l border-white": !disabled,
    "bg-neutral-gray hover:bg-neutral-gray border-l border-neutral-mid-gray": disabled,
    "!px-1.5": size === "xs" || size === "sm",
    "!px-2.5": size === "md",
    "!px-3": size === "lg" || size === "xl",
  },
];

export const getVariantClass = (variant: ButtonVariant) => {
  switch (variant) {
    case "secondary":
      return "bg-white text-neutral-dark-gray border enabled:border-neutral-mid-gray hover:bg-neutral-gray disabled:!bg-neutral-gray disabled:!text-neutral-silver-gray";
    case "tertiary": // TODO: remove this variant and use secondary instead
      return "bg-white text-neutral-dark-gray border enabled:border-neutral-mid-gray hover:bg-neutral-gray disabled:!bg-neutral-gray disabled:!text-neutral-silver-gray";
    case "tertiary-light":
      return "bg-transparent hover:bg-primary-light hover:text-primary-dark disabled:!text-neutral-silver-gray";
    case "info":
      return "bg-info text-white hover:bg-info/70 disabled:!bg-info-light";
    case "primary":
      return "bg-primary text-white border border-primary hover:bg-primary-dark disabled:!border-0 disabled:!bg-neutral-gray disabled:!text-neutral-silver-gray";
    default:
      return "bg-transparent hover:bg-transparent hover:opacity-70 disabled:!bg-neutral-gray disabled:!text-neutral-dark-gray";
  }
};
